export class RequestError extends Error {
  constructor(
    message: string,
    public additionalInfo?: { tags?: Record<string, string | number | undefined>; [other: string]: unknown }
  ) {
    super(message);
    this.name = 'RequestError';
    this.message = message;
    this.additionalInfo = additionalInfo;
  }
}
